import Cookies from 'js-cookie'

const TokenKey = 'token'
const CompanyKey = 'companyId'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getCompanyId() {
  return Cookies.get(CompanyKey)
}

export function setCompanyId(companyId) {
  return Cookies.set(CompanyKey, companyId)
}

export function removeCompanyId() {
  return Cookies.remove(CompanyKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js